var exports = {
  "S": "xaf9ae18d--8a9705--desktop-banner",
};

module.exports = exports;
